<div class="confirm-dialog">
  <div mat-dialog-content>
  <p style="font-size: 16px;">{{message}}</p>
  </div>
  <div mat-dialog-actions class="confirm-dialog-actions">
    <button mat-button class="confirm-btns" (click)="onNoClick()">No</button>
    <button mat-button class="confirm-btns" [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
  </div>
</div>